import React, { useState, useContext, createContext } from 'react'

type ModalType = 'deposit' | 'connect' | 'none'

interface ContextProps {
  setCurrentModal: any
  currentModal: ModalType
}

const ModalContext = createContext<Partial<ContextProps>>({})

export const ModalProvider = ({ children }: { children: React.ReactChild }) => {
  const [currentModal, setCurrentModal] = useState<ModalType>('none')
  return (
    <ModalContext.Provider value={{ currentModal, setCurrentModal }}>
      {children}
    </ModalContext.Provider>
  )
}

export const useModal = () => {
  const { currentModal, setCurrentModal } = useContext(ModalContext)

  const toggleModal = (modalType: ModalType) => {
    setCurrentModal(modalType)
  }

  return { currentModal, toggleModal }
}
